module.exports = __webpack_public_path__ + "static/china-flag-8db2791f1434e38bfd60e9ca94612b0e.svg";